export default [
  {
    path: "/tests/:testId",
    props: true,
    component: () => import("@/views/tests/Test.vue"),
    meta: {
      authorization: { policies: ["authenticated"] },
    },
  },
];
